import { requireAnySystemPermission, requireOrgPermission } from '../../../../../backend/features/permissions/shared';
import { SectionListItemButton } from '../../../../../ui/components/SectionListItemButton';
import { useUserState } from '../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { List } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { useOrganizationSections } from '../../hooks/useOrganizationSections';
export const OrganizationSectionList = (props) => {
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const sections = useOrganizationSections().sections || [];
    const hasRequiredPermission = (section) => {
        return (requireAnySystemPermission(userState, 'manage-organizations') ||
            section.columns.requireOrgPermission === undefined ||
            (section.columns.requireOrgPermission &&
                requireOrgPermission(userState, props.organizationId, section.columns.requireOrgPermission)));
    };
    const hasViewHistorySystemPermission = requireAnySystemPermission(userState, 'view-organization-history');
    const hasViewHistoryOrgPermission = requireOrgPermission(userState, props.organizationId, 'view-organization-history');
    return (React.createElement(List, { "data-test": 'organization-section-list' },
        sections.length === 0
            ? null
            : sections.filter(hasRequiredPermission).map((section, ind) => (React.createElement(SectionListItemButton, { key: section.id, showTopDivider: ind === 0, primaryText: section.columns.name, "data-test": section.columns.key ? 'section-' + section.columns.key : undefined, "data-test-section-name": section.columns.name, onClick: () => {
                    const urlParams = new URLSearchParams();
                    if (section.columns.name.toLowerCase() === 'members') {
                        urlParams.set('filter', JSON.stringify({
                            systemStatus: ['active'],
                            orgStatusInStaticOrg: [`${props.organizationId}_accepted`],
                        }));
                    }
                    navigationContext.navigate(() => navigate({
                        pathname: props.onResolveNavigationPathname
                            ? props.onResolveNavigationPathname(section.columns.name)
                            : `${props.organizationId}/${section.columns.name.toLowerCase()}`,
                        search: urlParams.toString(),
                    }, { state: { back: true } }));
                } }))),
        props.onShowHistory && (hasViewHistorySystemPermission || hasViewHistoryOrgPermission) && (React.createElement(React.Fragment, null, sections.length === 0 ? null : (React.createElement(SectionListItemButton, { showTopDivider: false, primaryText: t('panels.organizations.history'), "data-test-section-name": 'history', onClick: props.onShowHistory }))))));
};
